type StorageKey = "requests" | "certificates" | "renews" | "users";

export const parseSessionStorage = <T>(key: StorageKey, data: T) => {
    const temp = JSON.stringify(data);
    window.sessionStorage.setItem(key, temp);
};

export const getSessionStorage = <T>(key: StorageKey) => {
    const data = window.sessionStorage.getItem(key);
    if (data) {
        return JSON.parse(data) as T;
    }
    return null;
};

export const pasrseLocalStorage = <T>(key: StorageKey | string, data: T) => {
    const temp = JSON.stringify(data);
    window.localStorage.setItem(key, temp);
};

export const getLocalStorage = <T>(key: StorageKey | string) => {
    const data = window.localStorage.getItem(key);
    if (data) {
        return JSON.parse(data) as T;
    }
    return null;
};
